import React, { ReactNode } from 'react'

interface Props {
    className?: string
}

/**
 * Pretty (non-emoji) error mark shown in place of the checkbox when a task `failed`. A soft red
 * filled circle with a rounded cross, sized to match the 1rem checkbox box.
 */
export const TasksProgressionErrorIcon = ({ className = '' }: Props): ReactNode => {
    return (
        <span
            aria-hidden="true"
            className={`inline-flex h-4 w-4 shrink-0 items-center justify-center ${className}`}
            data-testid="tasks-progression-error-icon"
        >
            <svg viewBox="0 0 16 16" className="h-4 w-4" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="8" cy="8" r="8" className="fill-error-600" />
                <path
                    d="M5.5 5.5L10.5 10.5M10.5 5.5L5.5 10.5"
                    stroke="white"
                    strokeWidth="1.75"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        </span>
    )
}
